<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title
      ><mat-icon>{{ icon }}</mat-icon
      ><span>{{ title }}</span></mat-card-title
    >
  </mat-card-header>
  <mat-card-content>
    <p>
      Select the external coordinator from an external service provider to
      assign the inspection
    </p>
    @if (multiDropdownField && multiDropdownControl) {
      <cotecna-multidropdown
        [field]="multiDropdownField"
        [control]="multiDropdownControl"
        (fieldChange)="onSelectServiceProviderCoordinators($event.detail)"
      >
      </cotecna-multidropdown>
      <p>
        Assigned coordinator will be able to view inspection details and assign
        External inspectors. Do you want to proceed?
      </p>
    }
  </mat-card-content>
  <mat-card-actions align="end">
    <button id="cancel-additionalInfo" (click)="cancel()" mat-button>
      CANCEL
    </button>
    <button
      id="save-additionalInfo"
      (click)="assign()"
      mat-raised-button
      color="primary"
    >
      ASSIGN
    </button>
  </mat-card-actions>
</mat-card>
